import { StyleGuideWorkspaceComponent } from './style-guide/style-guide-workspace/style-guide-workspace.component';
import { StyleGuidePaletteComponent } from './style-guide/style-guide-palette/style-guide-palette.component';
import { StyleGuideTypographyComponent } from './style-guide/style-guide-typography/style-guide-typography.component';

export const components = [
  StyleGuideWorkspaceComponent,
  StyleGuidePaletteComponent,
  StyleGuideTypographyComponent
];
